import React from 'react';

import { cn } from '@change/ds-utils';

import imageSkeletonOverlay from 'src/assets/starterDashboardV2/readyToShare/imageSkeletonOverlay.svg';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { footerShapes } from './footer.constants';
import type { FacebookGroupPostComponentsProps } from './types';

export const Footer: React.FC<FacebookGroupPostComponentsProps> = (props) => {
	const { loading, size } = props;

	if (loading) return null;

	return (
		<SkeletonContainer className="flex flex-col" data-testid="footer-skeleton">
			<div className={cn('flex flex-row items-center justify-start', footerShapes.profileSkeleton.styles[size])}>
				<Circle size={size} />
				<div className={cn('flex flex-col', footerShapes.profileSkeleton.rectangles.styles[size])}>
					{footerShapes.profileSkeleton.rectangles.shapes.map((rectangle) => (
						<Rectangle key={rectangle.key} rounded className={rectangle.sizes[size]} />
					))}
				</div>
			</div>
			<div className={cn('flex flex-col', footerShapes.paragraphSkeleton.styles[size])}>
				{footerShapes.paragraphSkeleton.rectangles.map((rectangle) => (
					<Rectangle key={rectangle.key} rounded className={rectangle.sizes[size]} />
				))}
			</div>
			<div className={cn('relative w-full', footerShapes.imageSkeletonContainer.styles[size])}>
				<Rectangle className={footerShapes.imageSkeleton.styles[size]} />
				<img src={imageSkeletonOverlay} className={footerShapes.imageSkeletonOverlay.styles[size]} aria-hidden alt="" />
			</div>
		</SkeletonContainer>
	);
};
